module.exports = __webpack_public_path__ + "img/Urban_management.f7641532.jpg";